
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { IfComp, PanelSectionTitle } from '../../core';

import { getValueDefinitions } from './measureUtils';

const MeasureValue = (props) => {

    const classNames = mergeStyleSets({
        root: {
            paddingLeft: 16,
            paddingTop: 2,
            paddingBottom: 2
        },
        title: {
            width: 180
        },
        unit: {
            paddingLeft: 4
        },
        value: {
            paddingLeft: 4,
            width: 90,
            textAlign: 'right'
        }
    });

    const getValue = (value) => {
        return value.toFixed(2);
    }

    return (
        <Stack horizontal className={classNames.root}>
            <div className={classNames.title}>{props.value.title}:</div>
            <div className={classNames.value}>{getValue(props.value.value)}</div>
            <div className={classNames.unit}>{props.value.unit}</div>
        </Stack>
    );
}

const MeasureValues = ({values}) => {

    const classNames = mergeStyleSets({
        root: {
        },
        title: {
            fontSize: 14,
            fontWeight: 'bold',
            padding: '5px 0 5px 0'
        }
    });

    const valueDefinitions = getValueDefinitions(values);

    return (
        <IfComp cond={(valueDefinitions.length > 0)}>
            <div className={classNames.root}>
                <PanelSectionTitle title="Seznam hodnot aktuálního měření" />
                {valueDefinitions.map(item => {
                    return (
                        <MeasureValue key={item.name} value={item} />
                    );
                })}
            </div>
        </IfComp>
    );
}

export default MeasureValues;
